<template>
  <section class="why-proxify-section">
    <div class="rows">
      <div class="first-row container">
        <div class="image-container">
          <NuxtPicture
            src="/images/roles/why-proxify/dev_with_phone.png"
            alt="hero"
            lazy
          />
          <NuxtPicture
            src="/images/roles/why-proxify/dev_with_phone_mobile.png"
            alt="hero"
            lazy
          />
        </div>

        <div class="heading">
          <h1>Why join Proxify?</h1>
          <p>
            Enjoy exclusive benefits, alongside 3000+ members of Europe’s
            largest tech talent network.
          </p>
        </div>
      </div>

      <div class="second-row">
        <ControlSlider
          hide-navigation-desktop
          variant="light"
        >
          <template #slides>
            <div
              v-for="(carouselItem, index) in carouselItems"
              :key="index"
              class="card"
            >
              <Item :item="carouselItem" />
            </div>
          </template>
        </ControlSlider>
      </div>
    </div>

    <div class="bottom-wrapper">
      <div class="container">
        <p class="logo-paragraph">
          We're honored to be recognized for our achievements as a remote,
          global company, and a leader in tech talent.
        </p>
        <span class="label">AWARDS:</span>
        <div class="logos">
          <NuxtImg
            v-for="(logo, index) in logos"
            :key="`${logo}-${index}`"
            :src="`/images/roles/why-proxify/${logo}`"
            :alt="logo"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Item from './Item/Item.vue';
import ControlSlider from '~/components/Common/ControlSlider/ControlSlider.vue';

export default {
  components: { ControlSlider, Item },
  data() {
    return {
      carouselItems: [
        {
          icon: '/images/home-page/developer-type/illustration1.svg',
          title: 'Join the top 2%',
          description:
            'Showcase your skills and enter an exclusive tech talent network trusted by Fortune 500 companies.',
        },
        {
          icon: '/images/home-page/benefits/money.svg',
          title: 'Trust and transparency',
          description:
            'Know your compensation and working hours in advance. No more nasty surprises.',
        },
        {
          icon: '/images/home-page/benefits/puzzle.svg',
          title: 'Efficiency',
          description:
            'No more endless interviews. Enjoy a streamlined hiring process.',
        },
        {
          icon: '/images/home-page/benefits/globe.svg',
          title: 'Networking',
          description:
            'Learn and grow alongside other ambitious, talented tech professionals.',
        },
      ],
      logos: ['gasell.svg', 'deel.svg', 'deloitte.png'],
    };
  },
};
</script>

<style lang="scss" scoped>
@import './WhyProxify.scss';
</style>
